import { OptionModel } from "../../common/types/OptionModel";

export const insertCustomerWithPasswordOptions: OptionModel[] =[
    {
        value: 1,
        label: "Müşteri Kodu"
    },
    {
        value: 2,
        label: "Vergi Numarası İlk 6 Hane"
    },
    {
        value: 3,
        label: "Vergi Numarası"
    },
    {
        value: 4,
        label: "Telefon Numarası İlk 6 Hane"
    },
    {
        value: 11,
        label: "Telefon Numarası"
    }
];